module.exports = __webpack_public_path__ + "media/assets/img/portrait/small/avatar-s-9-7213af996d16ad5b00e5116acbd12fab.jpg";